"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-dashboard"
  }, [_c("div", {
    staticClass: "section-header-title"
  }, [_c("h1", {
    staticClass: "title-page"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column col-options"
  }, [_c("card-filter-days", {
    staticClass: "mb-4",
    attrs: {
      time: _vm.timeDash,
      times: _vm.times
    },
    on: {
      "update:time": function updateTime($event) {
        _vm.timeDash = $event;
      }
    }
  }), _vm._v(" "), _c("b-button", {
    attrs: {
      type: "is-link"
    },
    on: {
      click: _vm.openServicesPage
    }
  }, [_vm._v("\n          Ver mais\n        ")]), _vm._v(" "), _vm.isAdmin ? _c("b-button", {
    attrs: {
      type: "is-link"
    },
    on: {
      click: _vm.openPainel
    }
  }, [_vm._v("\n          Painel\n        ")]) : _vm._e()], 1), _vm._v(" "), _c("div", {
    staticClass: "column align-right"
  }, [_c("card-filter-days", {
    staticClass: "mb-4",
    attrs: {
      time: _vm.typeSelected,
      times: _vm.typesConsults
    },
    on: {
      "update:time": function updateTime($event) {
        _vm.typeSelected = $event;
      }
    }
  })], 1)])]), _vm._v(" "), _vm.typeSelected === _vm.TYPE_ITEM_DASHBOARD.RECEPTIONIST ? _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column",
    on: {
      click: function click($event) {
        return _vm.showDrawerCardDetails("client_hive", _vm.timeDash, _vm.createdHiveConsolidated.qtyTotal);
      }
    }
  }, [_c("card-dashboard-monitor", {
    staticClass: "p-2 pl-4 pt-4",
    attrs: {
      "no-click": true,
      title: "CLIENTE » HIVE",
      "last-update": _vm.createdHiveConsolidated.lastUpdate,
      load: _vm.createdHiveConsolidated.isLoading,
      total: _vm.createdHiveConsolidated.qtyTotal,
      "total-error": _vm.createdHiveConsolidated.qtyErrors,
      "total-success": _vm.createdHiveConsolidated.qtySuccess,
      "total3-number": _vm.createdHiveConsolidated.qtyProcessing
    },
    on: {
      "update:lastUpdate": function updateLastUpdate($event) {
        return _vm.$set(_vm.createdHiveConsolidated, "lastUpdate", $event);
      },
      "update:last-update": function updateLastUpdate($event) {
        return _vm.$set(_vm.createdHiveConsolidated, "lastUpdate", $event);
      }
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "column",
    on: {
      click: function click($event) {
        return _vm.showDrawerCardDetails("hive_provider", _vm.timeDash, _vm.createdProviderConsolidated.qtyTotal);
      }
    }
  }, [_c("card-dashboard-monitor", {
    staticClass: "p-2 pl-4 pt-4",
    attrs: {
      title: "HIVE » PROVEDOR",
      "last-update": _vm.createdProviderConsolidated.lastUpdate,
      load: _vm.createdProviderConsolidated.isLoading,
      total: _vm.createdProviderConsolidated.qtyTotal,
      "total-error": _vm.createdProviderConsolidated.qtyErrors,
      "total-success": _vm.createdProviderConsolidated.qtySuccess,
      "total3-number": _vm.createdProviderConsolidated.qtyProcessing
    },
    on: {
      "update:lastUpdate": function updateLastUpdate($event) {
        return _vm.$set(_vm.createdProviderConsolidated, "lastUpdate", $event);
      },
      "update:last-update": function updateLastUpdate($event) {
        return _vm.$set(_vm.createdProviderConsolidated, "lastUpdate", $event);
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.typeSelected === _vm.TYPE_ITEM_DASHBOARD.RECEPTIONIST ? _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column",
    on: {
      click: function click($event) {
        return _vm.showDrawerCardDetails("provider_hive", _vm.timeDash, _vm.receivedHiveConsolidated.qtyTotal);
      }
    }
  }, [_c("card-dashboard-monitor", {
    staticClass: "p-2 pl-4 pt-4",
    attrs: {
      title: "PROVEDOR » HIVE",
      "last-update": _vm.receivedHiveConsolidated.lastUpdate,
      load: _vm.receivedHiveConsolidated.isLoading,
      total: _vm.receivedHiveConsolidated.qtyTotal,
      "total-error": _vm.receivedHiveConsolidated.qtyErrors,
      "total-success": _vm.receivedHiveConsolidated.qtySuccess,
      "total3-number": _vm.receivedHiveConsolidated.qtyProcessing
    },
    on: {
      "update:lastUpdate": function updateLastUpdate($event) {
        return _vm.$set(_vm.receivedHiveConsolidated, "lastUpdate", $event);
      },
      "update:last-update": function updateLastUpdate($event) {
        return _vm.$set(_vm.receivedHiveConsolidated, "lastUpdate", $event);
      }
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "column",
    on: {
      click: function click($event) {
        return _vm.showDrawerCardDetails("hive_client", _vm.timeDash, _vm.sendClientConsolidated.qtyTotal);
      }
    }
  }, [_c("card-dashboard-monitor", {
    staticClass: "p-2 pl-4 pt-4",
    attrs: {
      "no-click": true,
      title: "HIVE » CLIENTE",
      "last-update": _vm.sendClientConsolidated.lastUpdate,
      load: _vm.sendClientConsolidated.isLoading,
      total: _vm.sendClientConsolidated.qtyTotal,
      "total-error": _vm.sendClientConsolidated.qtyErrors,
      "total-success": _vm.sendClientConsolidated.qtyTotal,
      "total3-number": _vm.sendClientConsolidated.qtyReceivedFailed,
      "error-label": "requisições com erro",
      "total3-label": "com falha no recebimento",
      "total3-color": "is-danger"
    },
    on: {
      "update:lastUpdate": function updateLastUpdate($event) {
        return _vm.$set(_vm.sendClientConsolidated, "lastUpdate", $event);
      },
      "update:last-update": function updateLastUpdate($event) {
        return _vm.$set(_vm.sendClientConsolidated, "lastUpdate", $event);
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.typeSelected !== _vm.TYPE_ITEM_DASHBOARD.MONITORING ? _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_c("card-api-consult-dead", {
    staticClass: "p-2 pl-4 pt-4",
    attrs: {
      title: "Total de erros",
      list: _vm.listServicesOnErrorTransactions,
      days: _vm.timeDash,
      load: _vm.isLoadingReceptionist,
      type: "transactions"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_vm.typeSelected === _vm.TYPE_ITEM_DASHBOARD.RECEPTIONIST ? _c("card-api-consult-dead", {
    staticClass: "p-2 pl-4 pt-4",
    attrs: {
      title: "Total de consultas",
      days: _vm.timeDash,
      list: _vm.arrConsolidatedGetsInLastDays,
      load: _vm.loadingConsolidatedGetsInLastDays,
      "protocol-column-name": "Response",
      "color-class": "primary",
      type: "transactions"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm.typeSelected !== _vm.TYPE_ITEM_DASHBOARD.MONITORING ? _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_c("card-api-request", {
    staticClass: "p-2 pl-4 pt-4",
    attrs: {
      "time-dash": _vm.timeDash,
      "type-selected": _vm.typeSelected
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.typeSelected === _vm.TYPE_ITEM_DASHBOARD.MONITORING ? _c("div", [_c("monitoring")], 1) : _vm._e(), _vm._v(" "), _c("modal-detail-card", {
    attrs: {
      "drawer-card-details": _vm.drawerCardDetails
    },
    on: {
      "update:drawerCardDetails": function updateDrawerCardDetails($event) {
        _vm.drawerCardDetails = $event;
      },
      "update:drawer-card-details": function updateDrawerCardDetails($event) {
        _vm.drawerCardDetails = $event;
      }
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;